<template>
  <Content nav="true" admin="true">
    <h1>Edit Bake</h1>
    <form class="pure-form pure-form-aligned" @change="save">
      <fieldset>
        <legend>Info</legend>
        <div class="pure-control-group">
          <label for="title">Title</label>
          <input v-model="bake.title" id="title" type="text" placeholder="Title">
        </div>
        <div class="pure-control-group">
          <label for="date">Date</label>
          <datetime type="datetime" v-model="bake.date"></datetime>
        </div>
        <div class="pure-control-group">
          <label for="icon">Icon</label>
          <span class="pure-button-group">
            <a
              v-for="icon in iconList"
              :key="icon[1]"
              @click.prevent="selectIcon(icon)"
              class="pure-button button-xsmall"
              :class="{'pure-button-active button-secondary': bake.icon && bake.icon[1] == icon[1]}"
            >
              <font-awesome-icon :icon="icon"/>
            </a>
          </span>
        </div>
        <div class="pure-control-group">
          <label for="description">Description</label>
          <textarea v-model="bake.description" id="description" placeholder="Description"></textarea>
        </div>
        <div class="pure-controls">
          <label for="nsfw" class="pure-checkbox">
            <input v-model="bake.nsfw" id="nsfw" type="checkbox">&nbsp; Not safe for work
          </label>
        </div>
      </fieldset>
      <fieldset>
        <legend>Images</legend>
        <button
          class="pure-button button-success"
          v-show="uploadProgress == 0"
          @click.prevent="selectFile"
          :disabled="uploading"
        >
          <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon>&nbsp; Upload Image
        </button>
        <button
          class="pure-button"
          disabled
          v-show="uploadProgress > 0"
        >Uploading: {{ uploadProgress }}%</button>
        <input type="file" :multiple="false" ref="uploadInput" @change="detectFiles($event)">
        <p>
          <a
            href="#"
            v-for="(value, name) in bake.images"
            :key="name"
            @click.prevent="deleteImage(name)"
          >
            <img :src="value" class="pic">
          </a>
        </p>
      </fieldset>
    </form>
  </Content>
</template>

<script>
import Session from '@/mixins/Session.js'
import { Datetime } from 'vue-datetime'
import imageCompression from 'browser-image-compression'

export default {
  name: 'Bake',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  props: ['id'],
  components: { datetime: Datetime, imageCompression },
  data() {
    return {
      iconList: [
        ['far', 'hamburger'],
        ['fas', 'cookie-bite'],
        ['far', 'birthday-cake'],
        ['fas', 'cauldron']
      ],
      bake: {},
      uploading: false,
      uploadProgress: 0,
      uploadTask: null
    }
  },
  methods: {
    getBake() {
      this.$database
        .collection('bakes')
        .doc(this.id)
        .get()
        .then(doc => {
          this.bake = doc.data()
          this.selectIcon(this.bake.icon)
        })
    },
    selectIcon(icon) {
      this.bake.icon = icon
      this.save()
    },
    formatBake() {
      this.bake.title = this.bake.title.trim()
      this.bake.description = this.bake.description.trim()
    },
    save() {
      this.formatBake()
      this.$database
        .collection('bakes')
        .doc(this.id)
        .set(this.bake)
    },
    selectFile() {
      this.$refs.uploadInput.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(fileList).forEach(file => this.compressFile(file))
    },
    compressFile(file) {
      this.uploading = true
      imageCompression(file, { maxSizeMB: 0.2 }).then(compressed =>
        this.uploadFile(compressed)
      )
    },
    uploadFile(file) {
      this.uploadTask = this.$storage.ref(`bakes/${file.name}`).put(file)
    },
    deleteImage(ref) {
      if (confirm(`Remove ${ref}?`)) {
        this.$storage
          .ref(ref)
          .delete()
          .then(() => {
            this.bake.images = Object.fromEntries(
              Object.entries(this.bake.images).filter(([k, v]) => k !== ref)
            )
            this.save()
          })
      }
    }
  },
  mounted() {
    this.getBake()
  },
  watch: {
    uploadTask: function() {
      this.uploadTask.on(
        'state_changed',
        sp => {
          this.uploadProgress = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          )
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(url => {
            this.bake.images[this.uploadTask.snapshot.metadata.fullPath] = url
            this.save()
            this.uploadProgress = 0
            this.uploading = false
          })
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.vdatetime {
  display: inline-block;
}

textarea {
  height: 10em;
  width: 50%;
}

input[type='file'] {
  clip: rect(0, 0, 0, 0);
  position: absolute;
}

.pic {
  max-height: 150px;
  max-width: 150px;
  margin-right: 1em;
  margin-bottom: 1em;
}
</style>
